import { render, staticRenderFns } from "./ProjectTissueSubmissionForm.vue?vue&type=template&id=4e9a5034"
import script from "./ProjectTissueSubmissionForm.vue?vue&type=script&lang=js"
export * from "./ProjectTissueSubmissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports